// Labels and order from the file format review (Edvardas, 2026-10-02):
// https://docs.google.com/spreadsheets/d/1Zf2naX8i_oDvV0DeSloS_ef5W3TppgeGtVt9dXNxzsI
// Keyed by production FileType id. Backend titles stay untouched because the legacy listing page,
// item pages and uploads share them. Several ids under one label merge formats the backend lists
// separately (Inventor, Lumion). USD joined the popular formats on 2026-10-20.
export const POPULAR_FORMATS_COUNT = 11

export const FILE_FORMAT_OPTIONS = [
  // 1. Popular, by usage
  { ids: ['12'], label: 'OBJ (.obj, .mtl)' },
  { ids: ['21'], label: 'Blender (.blend)' },
  { ids: ['5'], label: 'FBX (.fbx)' },
  { ids: ['51'], label: 'STL (.stl)' },
  { ids: ['117'], label: 'glTF (.gltf, .glb)' },
  { ids: ['17'], label: '3ds Max (.max)' },
  { ids: ['11'], label: 'Maya (.ma, .mb)' },
  { ids: ['14'], label: 'SketchUp (.skp)' },
  { ids: ['6'], label: 'Cinema 4D (.c4d)' },
  { ids: ['13'], label: 'Rhino (.3dm)' },
  { ids: ['207'], label: 'USD (.usd)' },
  // 2. Everything else, listed A-Z by buildFileFormatOptions
  { ids: ['89'], label: '3D Coat (.3b)' },
  { ids: ['2'], label: '3D Studio (.3ds)' },
  { ids: ['129'], label: '3MF (.3mf)' },
  { ids: ['90'], label: 'AC3D (.ac)' },
  { ids: ['147'], label: 'ACIS (.sat)' },
  { ids: ['116'], label: 'Adobe Dimension (.asd, .dn)' },
  { ids: ['104'], label: 'Alembic (.abc)' },
  { ids: ['130'], label: 'Alias (.wire)' },
  { ids: ['139'], label: 'Alibre / Geomagic (.ad_prt, .ad_asm, .ad_dwg, .ad_smp, .ad_pkg)' },
  { ids: ['191'], label: 'AMF (.amf)' },
  { ids: ['111'], label: 'ArchiCAD (.gsm)' },
  { ids: ['200'], label: 'ArtCAM (.art)' },
  { ids: ['91'], label: 'Artlantis (.atl, .atla, .atlo)' },
  { ids: ['4'], label: 'AutoCAD (.dwg)' },
  { ids: ['226'], label: 'Binary G-code (.bgcode)' },
  { ids: ['68'], label: 'Blitz3D (.b3d)' },
  { ids: ['209'], label: 'Blockbench (.bbmodel)' },
  { ids: ['23'], label: 'Bryce (.br5, .obp)' },
  { ids: ['144'], label: 'BVH motion capture (.bvh)' },
  { ids: ['202'], label: 'C3D motion capture (.c3d)' },
  { ids: ['113'], label: 'CATIA (.CATProduct, .CATMaterial, .CATAnalysis)' },
  { ids: ['60'], label: 'Cheetah3D (.jas)' },
  { ids: ['225'], label: 'Chitubox Slicer project (.chitubox)' },
  { ids: ['183'], label: 'Clarisse iFX (.project)' },
  { ids: ['25'], label: 'Collada (.dae)' },
  { ids: ['135'], label: 'CryEngine (.cga, .cgf, .chr, .skin)' },
  { ids: ['206'], label: 'D5 Render (.drs)' },
  { ids: ['102'], label: 'DAZ Studio (.duf)' },
  { ids: ['7'], label: 'DXF (.dxf)' },
  { ids: ['201'], label: 'FBX media folder (.fbm)' },
  { ids: ['131'], label: 'formZ (.fmz)' },
  { ids: ['107'], label: 'Fusion 360 (.f3d)' },
  { ids: ['220'], label: 'G-code (.gcode, .mpt, .mpf, .nc)' },
  { ids: ['227'], label: 'Gaussian splat (.splat)' },
  { ids: ['192'], label: 'GrowFX' },
  { ids: ['99'], label: 'Houdini (.hda, .hip, .bgeo, .geo, .bclip, .clip, .hipnc)' },
  { ids: ['103'], label: 'iClone (.iprop, .iAcc, .iCloth, .iAvatar, .iEffect)' },
  { ids: ['29'], label: 'IGES (.ige, .igs, .iges)' },
  { ids: ['71', '146'], label: 'Inventor (.iam, .ipt, .idw)' },
  { ids: ['82'], label: 'JewelCAD (.jcad, .jcd)' },
  { ids: ['149'], label: 'KeyShot (.bip, .ksp)' },
  { ids: ['63'], label: 'Leadwerks (.gmf)' },
  { ids: ['8'], label: 'LightWave (.lwo, .lw, .lws)' },
  { ids: ['145', '196', '199', '223'], label: 'Lumion (.ls8, .ls9, .ls10, .ls11)' },
  { ids: ['221'], label: 'LYC (.lyc)' },
  { ids: ['224'], label: 'Lychee Slicer project (.lys)' },
  { ids: ['184'], label: 'Mari (.mra)' },
  { ids: ['137'], label: 'Marmoset Toolbag (.tbscene, .tbmat)' },
  { ids: ['140'], label: 'Marvelous Designer (.zpac, .avt, .pos, .ZPrj)' },
  { ids: ['185'], label: 'MAT (.mat)' },
  { ids: ['35'], label: 'Maxwell Render (.mxs)' },
  { ids: ['108'], label: 'MDL Material (.mdl)' },
  { ids: ['67'], label: 'MilkShape 3D (.ms3d)' },
  { ids: ['33'], label: 'Modo (.lxo, .lxl)' },
  { ids: ['115'], label: 'Mudbox (.mud)' },
  { ids: ['114'], label: 'Octane Render (.orbx)' },
  { ids: ['197'], label: 'OpenVDB (.vdb)' },
  { ids: ['210'], label: 'Parasolid (.x_t, .x_b)' },
  { ids: ['189'], label: 'PLY (.ply)' },
  { ids: ['40'], label: 'Poser (.pz3, .pp2)' },
  { ids: ['42'], label: 'RenderMan (.rib, .slc, .sl, .slo)' },
  { ids: ['141'], label: 'Revit (.rfa, .rvt)' },
  { ids: ['47'], label: 'Shockwave 3D (.w3d)' },
  { ids: ['48'], label: 'Silo (.sia)' },
  { ids: ['15'], label: 'Softimage (.hrc, .xsi)' },
  { ids: ['70'], label: 'Solid Edge (.asm, .par, .psm, .dft)' },
  { ids: ['59'], label: 'SolidWorks (.sldprt, .sldasm, .slddrw)' },
  { ids: ['72'], label: 'STEP (.stp)' },
  { ids: ['133'], label: 'Strata 3D (.s3d)' },
  { ids: ['123'], label: 'Substance Designer (.sbs, .sbsprs, .sbsar)' },
  { ids: ['101'], label: 'Substance Painter (.spp, .sbsar, .spsm)' },
  { ids: ['98'], label: 'Terragen (.tgo)' },
  { ids: ['66'], label: 'Torque 3D (.dts)' },
  { ids: ['134'], label: 'trueSpace (.cob, .scn, .rsobj, .rsscn)' },
  { ids: ['205'], label: 'Twinmotion (.tm)' },
  { ids: ['83'], label: 'Unity (.unitypackage, .prefab)' },
  { ids: ['96'], label: 'Unreal Engine (.uasset)' },
  { ids: ['127'], label: 'USDZ (.usdz)' },
  { ids: ['208'], label: 'Vectorworks (.vwx)' },
  { ids: ['188'], label: 'VRML (.wrl)' },
  { ids: ['54'], label: 'Vue (.vue)' },
  { ids: ['55'], label: 'ZBrush (.ztl, .zbp)' },
  { ids: ['214'], label: 'EPS (.eps)' },
  { ids: ['219'], label: 'EXR (.exr)' },
  { ids: ['28'], label: 'High-res renderings (.hrd)' },
  { ids: ['213'], label: 'Illustrator (.ai)' },
  { ids: ['216'], label: 'JPG (.jpg)' },
  { ids: ['222'], label: 'MP4 video (.mp4)' },
  { ids: ['100'], label: 'PDF (.pdf)' },
  { ids: ['217'], label: 'Photoshop (.psd)' },
  { ids: ['215'], label: 'PNG (.png)' },
  { ids: ['212'], label: 'SVG (.svg)' },
  { ids: ['110'], label: '3ds Max MAXScript (.ms)' },
  { ids: ['187'], label: '3ds Max MCG tool (.mcg)' },
  { ids: ['204'], label: '3ds Max render preset (.rps)' },
  { ids: ['228'], label: 'JSON (.json)' },
  { ids: ['218'], label: 'Machine training bundle (.mtb)' },
  { ids: ['120'], label: 'Maya MEL script (.mel)' },
  { ids: ['119'], label: 'Python script (.py, .pyc)' },
  { ids: ['229'], label: 'PyTorch (.pt, .pth)' },
  { ids: ['230'], label: 'PyTorch Lightning (.ckpt)' },
  { ids: ['231'], label: 'YAML (.yaml)' },
]

const cleanBackendLabel = label => label
  .replace(/,\s*,/g, ',')
  .replace(/,\s*\)/g, ')')
  .replace(/\(\s*,/g, '(')
  .replace(/,\s*,\s*/g, ', ')
  .replace(/\s+/g, ' ')
  .trim()

const compareLabels = (a, b) => a.label.localeCompare(b.label, 'en', { sensitivity: 'base', numeric: true })

// Merges the backend list (ListingPageFiltersHelper#file_types) with the curated order. Each
// option keeps every backend label of its ids: search still matches the old names ("Autodesk FBX",
// "Stereolithography") and tracking keeps reporting the label analytics already groups by. The
// popular formats keep their usage order; every other format, including ids the config does not
// know (a format added after the review, local seed data), follows in one A-Z list.
export const buildFileFormatOptions = (backendFilters = []) => {
  const backendLabels = new Map(backendFilters
    .map(filter => [String(filter.value), cleanBackendLabel(filter.label ?? '')])
    .filter(([, label]) => label))

  const curated = FILE_FORMAT_OPTIONS.flatMap(({ ids, label }, index) => {
    const presentIds = ids.filter(id => backendLabels.has(id))
    if (presentIds.length === 0) return []

    const oldLabels = presentIds.map(id => backendLabels.get(id))
    return [{
      value: presentIds[0],
      ids: presentIds,
      label,
      trackingLabel: oldLabels[0],
      searchText: [label, ...oldLabels].join(' ').toLowerCase(),
      isPopular: index < POPULAR_FORMATS_COUNT,
    }]
  })

  const curatedIds = new Set(FILE_FORMAT_OPTIONS.flatMap(option => option.ids))
  const unknown = [...backendLabels]
    .filter(([id]) => !curatedIds.has(id))
    .map(([id, label]) => ({
      value: id, ids: [id], label, trackingLabel: label, searchText: label.toLowerCase(), isPopular: false,
    }))

  const popular = curated.filter(option => option.isPopular)
  const rest = [...curated.filter(option => !option.isPopular), ...unknown].sort(compareLabels)

  return [...popular, ...rest]
}
